import React, { useEffect, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { getSignById } from '../data/signs';
import { BackButton } from '../components/layout/BackButton';
import { SignHero } from '../components/sign/SignHero';
import { SignProblema } from '../components/sign/SignProblema';
import { SignSolucion } from '../components/sign/SignSolucion';
import { SignDescubrir } from '../components/sign/SignDescubrir';
import { SignProductos } from '../components/sign/SignProductos';
import { SignReviews } from '../components/sign/SignReviews';
import { SignCTA } from '../components/sign/SignCTA';
import { FAQ } from '../components/home/FAQ';
const PROBLEMA_SOLUCION_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/Wo_P7B_zdv8m9RvhXj7oHsrVCD8DHmoaCV8LM93AvU4jwAaKiGqzNwGb4XYEagB9_tZ0TcHraHRe_tnjw_TqjyQZxuHl5rbrSK5lMOirgN3ahHy_2wo6yUvf1xmSggU58NRTNKzMv.jpg?v=1778629047';
export function SignPage() {
  const {
    signId
  } = useParams<{
    signId: string;
  }>();
  const sign = signId ? getSignById(signId) : null;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [signId]);
  if (!sign) {
    return <div className="min-h-screen flex items-center justify-center bg-cosmic-black" data-id="element-345">
        <p className="text-white text-xl" data-id="element-346">Signo no encontrado</p>
      </div>;
  }
  return <div className="w-full bg-cosmic-black" data-id="element-347">
      <BackButton signColor={sign.colors.primary} data-id="element-348" />
      <SignHero sign={sign} data-id="element-349" />

      {/* Combined background for SignProblema + SignSolucion, tinted with sign color */}
      <div className="relative" data-id="element-350">
        <div className="absolute inset-0 z-0" data-id="element-351">
          <img src={PROBLEMA_SOLUCION_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-352" />
          <div className="absolute inset-0 bg-cosmic-black/75" data-id="element-353" />
          <div className="absolute inset-0 mix-blend-color" style={{
          backgroundColor: sign.colors.primary,
          opacity: 0.35
        }} data-id="element-354" />
          <div className="absolute inset-0" style={{
          background: `linear-gradient(180deg, #050508 0%, ${sign.colors.primary}15 50%, #050508 100%)`
        }} data-id="element-355" />
        </div>
        <div className="relative z-10" data-id="element-356">
          <SignProblema sign={sign} data-id="element-357" />
          <SignSolucion sign={sign} data-id="element-358" />
        </div>
      </div>

      <SignDescubrir sign={sign} data-id="element-359" />
      <SignProductos sign={sign} data-id="element-360" />
      <SignReviews sign={sign} data-id="element-361" />
      <FAQ data-id="element-362" />
      <SignCTA sign={sign} data-id="element-363" />
    </div>;
}